var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.538 2.423H4.423A2.923 2.923 0 0 0 1.5 5.346v10.231A2.923 2.923 0 0 0 4.423 18.5h10.23a2.923 2.923 0 0 0 2.924-2.923v-3.115"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4D55",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.846 8.808a3.654 3.654 0 1 0 0-7.308 3.654 3.654 0 0 0 0 7.308"
})));
export default SvgNotification;